import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import classNames from 'classnames';
import TextField from '@mui/material/TextField';
import CategorieSelect from 'components/Shared/CategorieSelect';
import TypeSelect from 'components/Shared/TypeSelect';
import QualificationSelect from 'components/Shared/QualificationSelect';
import DropZone from 'components/Shared/DropZone';

const styles = theme => ({
    flexContainer: {
        display: 'flex',
        flexFlow: 'row wrap',
        justifyContent: 'space-between',
        alignItems: 'top',
        overflowY: 'auto',
        margin: 10
    },
    row: {
        flexBasis: '100%',
    },
    selectType: {
        flexBasis: '20%',
        padding: theme.spacing(1, 1, 1, 0)
    },
    selectCategorie: {
        flexBasis: '30%',
        padding: theme.spacing(1)
    },
    selectQualification: {
        flexBasis: '50%',
        padding: theme.spacing(1, 0, 1, 1)
    },
    scrollable: {
        flexBasis: '100%',
        overflowY: 'auto',
        maxHeight: '300px'
    }
});

class AddReclamationTypeStep extends React.Component {
    componentDidMount() {
        // On détermine si on doit rendre accessible le bouton pour passer à l'étape suivante.
        const { reclamation, onNextStepValid } = this.props;

        const nextStepValid = reclamation.type.id > 0 && reclamation.categorie.id > 0 && reclamation.qualification.id > 0;

        onNextStepValid(nextStepValid);
    }

    handleChange = (event) => {
        const { onChange, reclamation } = this.props;
        const name = event.target.name;
        const value = event.target.value;

        let errors = [];

        if (name !== 'qualificationId') {
            if (reclamation.qualification.id <= 0) {
                errors.push({ key: 'qualificationId', errorMsg: 'Qualification requise' });
            }
            else {
                errors.push({ key: 'qualificationId', errorMsg: null });
            }
            if (reclamation.categorie.id <= 0) {
                errors.push({ key: 'categorieId', errorMsg: 'Catégorie requise' });
            }
            else {
                errors.push({ key: 'categorieId', errorMsg: null });
            }
        } else {
            if (value <= 0) {
                errors.push({ key: 'qualificationId', errorMsg: 'Qualification requise' });
            } else {
                errors.push({ key: 'qualificationId', errorMsg: null });
            }
            if (reclamation.categorie.id <= 0) {
                errors.push({ key: 'categorieId', errorMsg: 'Catégorie requise' });
            }
            else {
                errors.push({ key: 'categorieId', errorMsg: null });
            }
        }

        onChange(event, errors);
    }

    handleChangeType = (event, type) => {
        const { onChangeType } = this.props;

        // On ajoute systématiquement une erreur puisque la catégorie est réinitialisée (et la qualification en cascade) lors du changement de type.
        let errors = [
            { key: 'categorieId', errorMsg: 'Catégorie requise' },
            { key: 'qualificationId', errorMsg: 'Qualification requise' }
        ];

        onChangeType(type, errors);
    }

    handleChangeCategorie = (event, categorie) => {
        const { onChangeCategorie } = this.props;

        // On ajoute systématiquement une erreur puisque la qualification est réinitialisée lors du changement de catégorie.
        let errors = [{ key: 'qualificationId', errorMsg: 'Qualification requise' }];
        if (event.target.value <= 0) {
            errors.push({ key: 'categorieId', errorMsg: 'Catégorie requise' });
        } else {
            errors.push({ key: 'categorieId', errorMsg: null });
        }

        onChangeCategorie(categorie, errors);
    }

    render() {
        const { classes, reclamation, validationErrors, reclamationLiee } = this.props;

        let typeError = validationErrors.find(e => e.key === 'typeId');
        let categorieError = validationErrors.find(e => e.key === 'categorieId');
        let qualificationError = validationErrors.find(e => e.key === 'qualificationId');

        return (
            <div className={classes.flexContainer}>
                <div className={classes.selectType}>
                    <TypeSelect value={reclamation.type.id}
                        error={typeError}
                        onChange={this.handleChangeType}
                        all={false}
                        reclamationLiee={reclamationLiee}
                        isRequired
                    />
                </div>
                <div className={classes.selectCategorie}>
                    <CategorieSelect
                        error={categorieError}
                        value={reclamation.categorie.id}
                        onChange={this.handleChangeCategorie}
                        typeId={reclamation.type.id}
                        isRequired
                        afficheAide
                        autoFocus
                        disabled={!reclamation.type.id}
                    />
                </div>
                <div className={classes.selectQualification}>
                    <QualificationSelect
                        error={qualificationError}
                        value={reclamation.qualification.id}
                        onChange={this.handleChange}
                        categorieId={reclamation.categorie.id}
                        isRequired
                        afficheAide
                        disabled={!reclamation.type.id && !reclamation.categorie.id}
                    />
                </div>

                <div className={classNames(classes.scrollable)}>
                    <div className={classes.row}>
                        <TextField
                            multiline
                            fullWidth
                            name="commentaire"
                            label="Commentaire"
                            placeholder="Décrire le problème rencontré"
                            maxRows="10"
                            margin="normal"
                            onChange={this.handleChange}
                            value={reclamation.commentaire}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </div>

                    <div className={classes.row}>
                        <DropZone id="fichiersIds" name="fichiersIds" onChange={this.handleChange} cleanOnUnmount={false} />
                    </div>

                </div>
            </div>
        );
    }
}

AddReclamationTypeStep.propTypes = {
    reclamation: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    onChangeType: PropTypes.func.isRequired,
    onChangeCategorie: PropTypes.func.isRequired,
    validationErrors: PropTypes.array.isRequired,
    onNextStepValid: PropTypes.func.isRequired,
    reclamationLiee: PropTypes.bool.isRequired
};

export default withStyles(styles)(AddReclamationTypeStep);